import { DashboardModule, Grid } from '@domain-group/suit-theme'

import useAgencySelector from '@hooks/useAgencySelector'
import useImageLibraries from '@hooks/useImageLibraries'

import ImageLibraryListItem from '../ImageLibraryListItem'

interface AgencyImageLibrariesProps {
  pageFilters: object,
}

const AgencyImageLibraries = (props: AgencyImageLibrariesProps) => {
  const { pageFilters } = props

  const { selectedAgencyId } = useAgencySelector()

  const imageLibrariesPayload = useImageLibraries({
    filters: {
      ...pageFilters,
      hidden: 'false',
      owner_id: selectedAgencyId,
      owner_type: 'Agency',
    },
    performHttpRequests: true,
    requestOptions: {
      include_image_library_cover_image: true,
      include_image_sizes: true,
    },
  })

  const {
    callbacks: {
      loadMore,
    },
    canLoadMore,
    filteredImageLibraries,
    filteredImageLibrariesCount,
    hasFilteredImageLibraries,
    loading,
  } = imageLibrariesPayload

  return (
    <DashboardModule
      boxProps={{ borderBottom: `${loading ? 'none' : ''}` }}
      contentBoxProps={{ flexDirection: 'column' }}
      loading={loading}
      title="Agency Image Libraries"
    >
      {!loading && !hasFilteredImageLibraries && (
        <DashboardModule.BlankState>
          <DashboardModule.BlankState.Title>
            No Agency Image Libraries Present
          </DashboardModule.BlankState.Title>

          <DashboardModule.BlankState.Paragraph>
            Please adjust your filters or create one above.
          </DashboardModule.BlankState.Paragraph>
        </DashboardModule.BlankState>
      )}

      {hasFilteredImageLibraries && !loading && (
        <>
          <DashboardModule.ScrollableSection>
            <Grid
              // @ts-expect-error TS2322
              gridGap="medium"
              gridAutoRows="1fr"
              gridTemplateColumns="repeat(auto-fill, minmax(160px, 1fr))"
              gridTemplateRows="repeat(auto-fill, minmax(120px, 1fr))"
              padding="large"
            >
              {filteredImageLibraries.map(imageLibrary => (
                <ImageLibraryListItem
                  key={imageLibrary.id}
                  imageLibrary={imageLibrary}
                />
              ))}
            </Grid>
          </DashboardModule.ScrollableSection>

          <DashboardModule.LoadMoreFooter
            boxProps={{ borderTop: loading ? 'none' : '1px solid' }}
            callbacks={{ loadMore }}
            canLoadMore={canLoadMore}
            entityCount={filteredImageLibrariesCount}
            loading={loading}
          />
        </>
      )}
    </DashboardModule>
  )
}

export default AgencyImageLibraries
